// #genai Matches the add-ach / add-card card shell so the skeleton does not jump when the form renders.
import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px',
    margin: '20px',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.12), 0px 0px 2px 0px rgba(0,0,0,0.14)',
    '@media (max-width: 639px)': {
      margin: '0px',
      padding: '16px 24px',
      borderRadius: '0px',
      boxShadow: 'none',
      flexGrow: 1,
    },
  },

  sections: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    maxWidth: '800px',
    '@media (max-width: 639px)': {
      maxWidth: 'none',
    },
  },

  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    width: '100%',
    '@media (max-width: 639px)': {
      flexDirection: 'column',
      gap: '24px',
    },
  },
}));
